<template>
    <div>
        <section-definition :title="page.title" :extraOptions="page.options" :icon="page.icon"
            :breadcrumbs="page.breadcrumbs" :addNewData="page.addnew" :exportOptions="page.exportOptions"
            @refreshPage="refreshThisPage" @addNew="AddNewRule" :style="styleObject"></section-definition>
        <loader v-if="page.loading"></loader>
        <v-container v-else fluid grid-list-xl page>
            <v-data-table :headers="headers" :items="TeamData" class="elevation-1 fixed-layout"
                :pagination.sync="pagination" :total-items="pagecount" :loading="tableLoading">
                <template v-slot:no-data style="text-align: center">
                    <div style="text-align: center">No Data Available</div>
                </template>
                <template v-slot:items="props">
                    <td class="checkEmpty p0">{{ props.item.name }}</td>
                    <td class="checkEmpty p0">{{ props.item.description }}</td>
                    <td class="checkEmpty p0">{{ props.item.user.length }}</td>
                    <td class="checkEmpty p0">
                        <template v-if="props.item.active === 0">Active</template>
                        <template v-else>Inactive</template>
                    </td>

                    <td class="text-xs-center checkEmpty p0">
                        <v-icon color="blue" small class="mr-4" v-if="page.canedit"
                            @click="editItem(props.item, props.index)">edit</v-icon>
                        <v-icon color="red" small class="mr-4" v-if="page.candelete"
                            @click="deleteItem(props.item.id)">delete</v-icon>
                    </td>
                </template>
            </v-data-table>
        </v-container>
        <v-dialog persistent v-model="DeleteRowdata" max-width="500px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-card-title>
                        <span class="headline">Delete Team</span>
                    </v-card-title>
                </v-toolbar>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-card-text>Are you sure to delete this Team?</v-card-text>
                    </v-layout>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="light" flat @click="closedelete()">Cancel</v-btn>
                    <v-btn color="primary" @click="savedelete()">Yes, Delete !</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent :value="page.isAddTeam" max-width="500px">
            <v-form ref="formcreate" v-model="addTeam.valid">
                <v-card style="height: 600px; overflow-y: auto;" class="teamhight">
                    <v-toolbar dark color="primary" style="width: 500px !important; z-index: 1;position: fixed;" >
                        <v-card-title>
                            <span class="headline">Create Team</span>
                        </v-card-title>
                    </v-toolbar>
                    <v-container grid-list-md style="margin-top: 60px;">
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field v-model="addTeam.payload.name" required label="Name" type="text"
                                    :rules="[(v) => !!v && v.trim() !== '' || 'Name is required']"></v-text-field>
                            </v-flex>

                            <v-flex xs12>
                                <v-text-field v-model="addTeam.payload.description" required label="Description"
                                    :rules="[(v) => !!v && v.trim() !== '' || 'Description is required']">
                                    type="text"></v-text-field>

                            </v-flex>
                            <v-flex xs12>
                                <v-select v-model="addTeam.payload.type" required label="Type" :items="Type"
                                :rules="[(v) => !!v && v.trim() !== '' || 'Type is required']"  item-text="name" item-value="value" @change="TypeChange"></v-select>
                            </v-flex>
                            <v-flex xs12 v-if="addTeam.payload.type == 'all' || addTeam.payload.type == 'source'">
                                <v-select v-model="type_data.source" :items="source" label="Lead Source" multiple
                                    item-text="name" item-value="id" :rules="sourceRules">
                                </v-select>
                            </v-flex>
                            <v-flex xs12 v-if="addTeam.payload.type == 'all' || addTeam.payload.type == 'channel'">
                                <v-select v-model="type_data.channel" :items="channel" label="Channel" item-text="name"
                                    :rules="channelRules" item-value="id" multiple>
                                </v-select>
                            </v-flex>

                            <v-flex xs12>
                                <v-select v-model="addTeam.payload.campaign" :items="campaign" label="Campagin" required
                                    :rules="[(v) => Array.isArray(v) && v.length > 0 || 'Campaign is required']"
                                    item-text="campaign_name" item-value="id" multiple>
                                </v-select>
                            </v-flex>
                            <v-flex xs12>
                                <template>

                                    <v-select v-model="value" :items="allmembers" :label="'User Assign'" multiple
                                        :rules="[(v) => Array.isArray(v) && v.length > 0 || 'User is required']"
                                        item-disabled="active" item-text="displayname" item-value="name">
                                        <template v-if="allmembers.length>0" v-slot:prepend-item>

                                           <v-checkbox @change="selectAll" v-model="selectall" :label="'Select All'"
                                                hide-details color="primary" style="margin-left: 16px;"></v-checkbox>


                                            <v-divider></v-divider> 
                                        </template>

                                        <template v-slot:selection="{ item, index }">
                                            <v-chip v-if="index < 2">
                                                <span>{{ item.name }}</span>
                                            </v-chip>
                                            <span v-if="index === 2" class="text-grey text-caption align-self-center">
                                                (+{{ value.length - 2 }} others)
                                            </span>
                                        </template>
                                    </v-select>
                                </template>


                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="light" flat @click="closeAddTeam()" >Close</v-btn>
                        <v-btn :disabled="!addTeam.valid" color="primary"  @click="saveAddTeam()"  >Create</v-btn>
                        
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <v-dialog persistent :value="page.isEditTeam" max-width="500px">

            <v-form ref="formupdate" v-model="valid">
                <v-card style="height: 600px; overflow-y: auto;" class="teamhight">
                    <v-toolbar dark color="primary" style="width: 500px !important; z-index: 1;position: fixed;" >
                        <v-card-title>
                            <span class="headline">Update Team</span>
                        </v-card-title>
                    </v-toolbar>
                    <v-container grid-list-md style="margin-top: 60px;" >
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field v-model="editTeam.name" required label="Name" type="text" readonly
                                    :rules="[(v) => !!v && v.trim() !== '' || 'Name is required']"></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field v-model="editTeam.description" required label="Description" type="text"
                                    :rules="[(v) => !!v && v.trim() !== '' || 'Description is required']">
                                    type="text"></v-text-field>

                            </v-flex>
                            <v-flex xs12>
                                <v-select v-model="editTeam.type" required label="Type" :items="Type" :rules="[(v) => !!v && v.trim() !== '' || 'Type is required']" item-text="name"
                                    item-value="value" @change="TypeChange"></v-select>
                            </v-flex>
                            <v-flex xs12 v-if="editTeam.type == 'all' || editTeam.type == 'source'">
                                <v-select v-model="type_data.source" :items="source" label="Lead Source" multiple
                                    item-text="name" item-value="id" :rules="sourceRules">
                                </v-select>
                            </v-flex>
                            <v-flex xs12 v-if="editTeam.type == 'all' || editTeam.type == 'channel'">
                                <v-select v-model="type_data.channel" :items="channel" label="Channel" item-text="name"
                                    :rules="channelRules" item-value="id" multiple>
                                </v-select>
                            </v-flex>
                            <v-flex xs12><v-select v-model="editTeam.campaign" :items="campaign" required
                                    label="Campagin"
                                    :rules="[(v) => Array.isArray(v) && v.length > 0 || 'Campaign is required']"
                                    item-text="campaign_name" item-value="id" multiple>
                                </v-select></v-flex>

                            <v-flex xs12>
                                <template>
                                 
                                    <v-select v-model="value" :items="allmembers" :label="'User Assign'" multiple
                                        :rules="[(v) => Array.isArray(v) && v.length > 0 || 'User is required']"
                                        item-disabled="active" item-text="displayname" item-value="name">
                                        <template v-slot:prepend-item>

                                            <v-checkbox @change="selectAll" v-model="selectall" :label="'Select All'"
                                                hide-details color="primary" style="margin-left: 16px;">
                                            </v-checkbox>



                                            <v-divider></v-divider>
                                        </template>
                                        <!-- <template v-slot:item="{ item, index }">
                                            {{ item }}
                                         
                                            <v-checkbox :label="item.name"  v-model="item.active"
                                                :disabled="item.active"
                                               ></v-checkbox>
                                        </template> -->
                                        <template v-slot:selection="{ item, index }">
                                            <v-chip v-if="index < 2">
                                                <span>{{ item.name }}</span>
                                            </v-chip>
                                            <span v-if="index === 2" class="text-grey text-caption align-self-center">
                                                (+{{ value.length - 2 }} others)
                                            </span>
                                        </template>
                                    </v-select>
                                </template>


                            </v-flex>
                            <v-flex xs12>
                                <v-select v-model="editTeam.active" required label="Status" :items="status"
                                    item-text="name" item-value="value"></v-select>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="light" flat @click="closeEditRules()">Close</v-btn>
                        <v-btn color="primary" :disabled="!valid"  @click="saveEditRules()">Update</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>

        </v-dialog>
        <v-snackbar v-model="snackbar.show" :bottom="true" :right="true" :timeout="snackbar.timeout">
            {{ snackbar.text }}
            <v-btn color="pink" flat @click="snackbar.show = false">Close</v-btn>
        </v-snackbar>
        <v-dialog v-model="isProcessing" hide-overlay persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    Please stand by
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import loader from "@/components/Widgets/loader";
//import api from "@/utils/axios-util";
export default {
    components: {
        loader
    },

    data() {
        return {
            selectall: false,
            allmembers: [],
            value: [],
            styleObject: {
                height: "80px",
                "margin-top": "-8px",
            },
            valid: true,
            page: {
                title: "Team Management",
                icon: "fa-clipboard fa-2x",
                loading: false,
                options: { filter: false, refresh: true },
                isAddTeam: false,
                playingRecord: false,
                breadcrumbs: [],
                exportOptions: [],
                addnew: [],
                isEditTeam: false,
                candelete: false,
                canedit: false,
            },
            pagecount: 0,
            headers: [
                {
                    text: "Name",
                    align: "left",
                    class: "p0",
                    sortable: false,
                    value: "name",
                },
                {
                    text: "Description",
                    align: "left",
                    class: "p0",
                    sortable: false,
                    value: "description",

                },
                {
                    text: "Assign Count",
                    align: "left",
                    class: "p0",
                    sortable: false,
                    value: "usercount",
                },
                {
                    text: "Status",
                    align: "left",
                    class: "p0",
                    sortable: false,
                    value: "status",
                },
                {
                    text: "Action",
                    align: "left",
                    sortable: false,
                    value: "btn",
                    width: "20%",
                },
            ],
            TeamData: [],
            pagination: {
                page: 1,
                rowsPerPage: 10,
            },
            snackbar: {
                show: false,
                timeout: 6000,
                text: "",
            },
            DeleteRowdata: false,
            showRowData: false,
            DataRow: false,
            tableLoading: false,
            filtervalue: [],
            filter: {
                payload: {
                    Team: "",
                    active: ""
                },
                options: {
                    status: ["Active", "Inactive"],
                },
            },
            isProcessing: false,
            call_status: [],
            editTeam: {
                id: "",
                name: "",
                description: "",
                active: 0,
                user: [],
                type: "",
                type_data: {
                    source: [],
                    channel: []
                },
                campaign: []
            },
            type_data: {
                source: [],
                channel: []
            },
            source: [],
            channel: [],
            addTeam: {
                valid: false,
                payload: {
                    name: "",
                    description: "",
                    active: 0,
                    user: [],
                    type: "",
                    type_data: {
                        source: [],
                        channel: []
                    },
                    campaign: []
                },
            },
            status: [{ name: "Active", value: 0 }, { name: "Inactive", value: 1 }],
            Type: [ { name: "All", value: "all" }, { name: "Lead Source", value: "source" }, { name: "Channel", value: "channel" },{ name: "None of the above", value: "none" }],
            typeRules: [
                (v) => !!v || "Type is required", // Ensure that a type is selected
            ],
            sourceRules: [],
            channelRules: [],
            team_user: [],
            user: [],
            campaign: [],
            payload: {
                skip: 0,
                take: 0
            },
            liveagents_users: [],
            liveAgentTime: null,
            Editusers: [],
            Editindex: 0
        };
    },
    methods: {
        selectmultiselectItem(data) {
            console.log(data, "hhhhhhhhhhhhhhhhhhhhhhhhh")
        },

        getdata() {
            var scope = this;



            scope.$store
                .dispatch("GetSource")
                .then((response) => {
                    if (response.status == 200) {
                        scope.source = response.data.data.filter((elm) => elm.active == 0)
                    } else if (response.status == 204) {
                        scope.source = []
                    }
                })
                .catch(function (error) {
                    scope.showSnackBar("error" + error);
                });
            scope.$store
                .dispatch("GetChannel")
                .then((response) => {
                    if (response.status == 200) {
                        scope.channel = response.data.data.filter((elm) => elm.active == 0)
                    } else if (response.status == 204) {
                        scope.channel = []
                    }

                })
                .catch(function (error) {
                    scope.showSnackBar("error" + error);
                });
            let payload = { skip: 0, take: 0, campaign_status: 'Y', All: true };
            scope.$store
                .dispatch("GetAsterCampaigns", payload)
                .then((response) => {
                    if (response.statusCode == 200) {
                        scope.campaign = response.data
                    }
                })
                .catch(function (error) {
                    scope.showSnackBar("error" + error);
                });

        },
        Createtoggle() {
            this.$nextTick(() => {
                if (this.CreateSelectAll) {
                    this.addTeam.payload.user = []
                    this.userdata(this.addTeam.payload.user)
                } else {
                    this.addTeam.payload.user = this.team_user.filter(elm => this.liveagents_users.includes(elm) == false)
                    this.userdata(this.addTeam.payload.user)
                }
            })
        },
        Updatetoggle() {
            this.$nextTick(() => {
                if (this.UpdateSelectAll) {
                    this.editTeam.user = []
                    this.userdata(this.editTeam.user)
                } else {
                    this.editTeam.user = this.team_user.filter(elm => this.liveagents_users.includes(elm) == false)
                    this.userdata(this.editTeam.user)
                }
            })
        },
        userdata(data) {
            console.log(data)
            this.$store.commit("filter_EmailId", { user_email: data });
        },
        refreshThisPage: function () {
            var scope = this;
            scope.page.loading = true;
            scope.getDataFromApi();
        },
        getDataFromApi() {
            var scope = this;
            scope.tableLoading = true;
            this.page.isFilterOpen = false;
            var { page, rowsPerPage } = scope.pagination;
            if (rowsPerPage == -1) {
                scope.payload.take = scope.pagecount;
            } else {
                scope.payload.take = rowsPerPage;
            }
            if (page != "" && page != undefined && page != null) {
                scope.skip = page;
            } else {
                scope.skip = 1;
            }
            scope.payload.skip = (scope.skip - 1) * scope.payload.take;
            return new Promise(() => {
                this.$store
                    .dispatch("GetTeam", scope.payload)
                    .then((response) => {
                        scope.tableLoading = false;
                        scope.page.loading = false;
                        if (response.status == 204) {
                            scope.TeamData = [];
                            scope.user = []
                        } else {
                            var datas = response.data.data;
                            scope.TeamData = datas;
                            scope.pagecount = response.data.count
                            scope.user = []
                            response.data.data.forEach((elm) => {
                                scope.user = [...scope.user, ...elm.user]
                            })
                            this.editTeam.id = "";
                            this.editTeam.name = "";
                            this.editTeam.description = "";
                            this.editTeam.user = [];
                            this.type_data.source = []
                            this.type_data.channel = []
                        }

                    })
                    .catch(function (error) {

                        scope.page.isAddTeam = false;
                        clearInterval(this.liveAgentTime)
                        scope.showSnackBar("error" + error);
                        this.value = []
                        this.page.isEditTeam = false;
                    });
            })
        },
        AddNewRule: function () {
            var scope = this;
            scope.$refs.formcreate.reset()
            this.$refs.formcreate.resetValidation()

            scope.$store
                .dispatch("fetchmembers")
                .then((response) => {
                    this.liveagent(response)
                    this.liveAgentTime = setInterval(() => {
                        this.liveagent(response)
                    }, 4000)
                })
                .catch(function (err) {
                    console.log(err, "errerrerrerr");
                });

            scope.page.isAddTeam = true;
            let admin_emails = JSON.parse(localStorage.getItem("admin_emails"));
            scope.user.forEach((elm) => {
                scope.team_user.forEach((e) => {
                    if (elm == e) {
                        if (scope.team_user.includes(e) && !admin_emails.includes(e)) {
                            let indexdata = scope.team_user.indexOf(e)
                            scope.team_user.splice(indexdata, 1)
                        }

                    }
                })
            })
            scope.team_user = [...scope.team_user]
        },
        closeEditRules: function () {
            this.value = []
            clearInterval(this.liveAgentTime)
            this.page.isEditTeam = false;
            this.type_data.source = []
            this.type_data.channel = []
        },
        closeAddTeam: function () {
            this.TeamData[this.Editindex] = this.Editusers
            this.page.isAddTeam = false;
            this.$refs.formcreate.reset();
            this.$refs.formcreate.resetValidation()
            this.type_data.source = []
            this.type_data.channel = []
            clearInterval(this.liveAgentTime)
        },
        saveEditRules() {
            var scope = this;

            this.userdata(scope.editTeam.user)


            scope.editTeam.user = []

            for(let i = 0; i < scope.value.length; i++ ){
                let elementvalue = scope.value[i]
                let data =  JSON.parse(localStorage.getItem("userdetails")).find((elm) => elm.user_email == elementvalue)
                if(data != undefined){
                    scope.editTeam.user.push({
                        email: elementvalue,
                        name: data ? data.user_name : "Unknown User name"
                    })
                }
            }




            let sourcedata = [], channel = [], campaigndata = []
            scope.type_data.source.forEach((tlm) => {
                let data = scope.source.find((elm) => elm.id == tlm)
                if (data !== undefined) {
                    sourcedata.push({ id: data.id, name: data.name })
                }


            })
            scope.type_data.channel.forEach((tlm) => {
                let data = scope.channel.find((elm) => elm.id == tlm)
                if (data !== undefined) {
                    channel.push({ id: data.id, name: data.name })
                }
            })
            scope.editTeam.campaign.forEach((tlm) => {
                let data = scope.campaign.find((elm) => elm.id == tlm)
                if (data !== undefined) {
                    campaigndata.push({ id: data.id, name: data.campaign_name })
                }
            })
            if (scope.editTeam.type === "none") {
               
                scope.editTeam.type_data.source = []
                scope.editTeam.type_data.channel = []
            } else {
                scope.editTeam.type_data.source = sourcedata
                scope.editTeam.type_data.channel = channel
            }
           
            // scope.editTeam.campaign = { campaign: campaigndata }
            let editpayload = { ...scope.editTeam }
            editpayload.campaign = { campaign: campaigndata }
            if (scope.editTeam.type === "none") {
                editpayload.type = null
            }
            scope.$store
                .dispatch("updateTeam", editpayload)
                .then(() => {
                    this.page.isEditTeam = false;
                    scope.page.isAddTeam = false;

                    scope.showSnackBar("Updated Successfully");

                    this.getDataFromApi();
                    this.userdata("")


                    clearInterval(this.liveAgentTime)

                    // scope.editTeam.campaign = []

                })
                .catch(function (error) {
                    scope.page.isAddTeam = false;
                    clearInterval(this.liveAgentTime)
                    scope.showSnackBar("error" + error);
                    this.page.isEditTeam = false;
                    this.value = []
                });


        },
        saveAddTeam() {
            try {
                var scope = this;
                let isvalid = scope.$refs.formcreate.validate()

                if (isvalid) {
                    this.userdata(scope.addTeam.payload.user)


                    let selectedData = {};
                    selectedData.selectedUser = scope.addTeam.payload.user;

                    scope.addTeam.payload.user = []

                    for(let i = 0; i < scope.value.length; i++ ){
                        let elementvalue = scope.value[i]
                        let data =  JSON.parse(localStorage.getItem("userdetails")).find((elm) => elm.user_email == elementvalue)
                        if(data != undefined){
                            scope.addTeam.payload.user.push({
                                email: elementvalue,
                                name: data ? data.user_name : "Unknown User name"
                            })
                        }
                    }

                    console.log(scope.addTeam.payload.user, "isvalidisvalidisvalidisvalid")
                    let sourcedata = [], channel = [], campaigndata = []
                    scope.type_data.source.forEach((tlm) => {
                        let data = scope.source.find((elm) => elm.id == tlm)
                        if (data !== undefined) {
                            sourcedata.push({ id: data.id, name: data.name })
                        }
                    })
                    scope.type_data.channel.forEach((tlm) => {
                        let data = scope.channel.find((elm) => elm.id == tlm)
                        if (data !== undefined) {
                            channel.push({ id: data.id, name: data.name })
                        }
                    })
                    scope.addTeam.payload.campaign.forEach((tlm) => {
                        let data = scope.campaign.find((elm) => elm.id == tlm)
                        if (data !== undefined) {
                            campaigndata.push({ id: data.id, name: data.campaign_name })
                        }
                    })
                    if (scope.addTeam.payload.type === "none") {
                       
                        scope.addTeam.payload.type_data.source = []
                        scope.addTeam.payload.type_data.channel = []
                    } else {
                        scope.addTeam.payload.type_data.source = sourcedata
                        scope.addTeam.payload.type_data.channel = channel
                    }
                    selectedData.selectedCampaign = scope.addTeam.payload.campaign;

                    // scope.addTeam.payload.campaign = { campaign: campaigndata }
                    let addpayload = { ...scope.addTeam.payload }
                    addpayload.campaign = { campaign: campaigndata }
                    if (scope.addTeam.payload.type === "none") {
                        addpayload.type = ""
            }
                    scope.$store
                        .dispatch("insertTeam", addpayload)
                        .then(() => {
                            scope.page.isAddTeam = false;
                            this.getDataFromApi();

                            clearInterval(this.liveAgentTime)
                            scope.showSnackBar("Created Successfully");
                            scope.addTeam.payload.name = "";
                            scope.addTeam.payload.description = "";
                            scope.addTeam.payload.user = [];
                            scope.addTeam.payload.campaign = []

                            this.userdata("")
                            scope.$refs.formcreate.reset()
                            this.$refs.formcreate.resetValidation()
                        })
                        .catch(function (error) {
                            if (error.response.status === 409) {
                                scope.showSnackBar('Team is already exist ');
                                scope.addTeam.payload.campaign = selectedData.selectedCampaign;
                                scope.addTeam.payload.user = selectedData.selectedUser;
                            } else {
                                scope.page.isAddTeam = false;
                                clearInterval(this.liveAgentTime)
                                scope.showSnackBar(error);
                                scope.addTeam.payload.name = "";
                                scope.addTeam.payload.description = "";
                                scope.addTeam.payload.user = [];
                                scope.addTeam.payload.campaign = [];
                                scope.$refs.formcreate.reset()
                                this.$refs.formcreate.resetValidation()
                                this.userdata("")
                            }
                        });


                }
            } catch (err) {
                console.log(err, "ppppppppppppppppppppppp")
            }
        },

        showSnackBar(message) {
            let scope = this;
            scope.snackbar.text = message;
            scope.snackbar.show = true;
            setTimeout(() => {
                scope.snackbar.text = "";
            }, scope.snackbar.timeout);
        },
        deleteItem(id) {
            this.DeleteRowdata = true;
            this.delete_id = id;
        },
        editItem(item, index) {
            item.user =  [...new Set(item.user)]
            let scope = this
            scope.$store
                .dispatch("fetchmembers")

                .then((response) => {
                    this.liveagent(response, item.user)
                    this.liveAgentTime = setInterval(() => {
                        this.liveagent(response, item.user)
                    }, 4000)
                })
                .catch(function (err) {
                    console.log(err, "errerrerrerr");
                });
            let admin_emails = JSON.parse(localStorage.getItem("admin_emails"));
            scope.Editusers = item.user
            this.value = item.user 
            scope.Editindex = index
            scope.user.forEach((elm) => {
                scope.team_user.forEach((e) => {
                    if (elm == e) {
                        if (scope.team_user.includes(e) && !admin_emails.includes(e)) {
                            let indexdata = scope.team_user.indexOf(e)
                            scope.team_user.splice(indexdata, 1)
                        }

                    }
                })
            })
            scope.team_user = [...scope.team_user, ...item.user]
            this.page.isEditTeam = true;
            this.editTeam.id = item.id;
            this.editTeam.name = item.name;
            this.editTeam.description = item.description;
            this.editTeam.user = item.user;
            this.editTeam.type =( item.type === null ||item.type === "")  ? "none":  item.type 
            this.editTeam.active = item.active
            this.editTeam.campaign = item.campaign.campaign.map((elm) => elm.id)
            this.type_data.source = item.type_data.source.map((elm) => elm.id)
            this.type_data.channel = item.type_data.channel.map((elm) => elm.id)
        },
        savedelete() {
            let scope = this;
            scope.isProcessing = true;
            this.$store
                .dispatch("deleteTeam", this.delete_id)
                .then((response) => {
                    scope.isProcessing = false;
                    if (response.data.message == "success") {
                        scope.getDataFromApi();
                        scope.showSnackBar("Team Deleted");
                        this.team_user = JSON.parse(localStorage.getItem("group_users"));
                    } else {
                        scope.showSnackBar("Error! Unable Delete list");
                    }
                })
                .catch(() => {
                    scope.isProcessing = false;
                    scope.showSnackBar("Error! Unable Delete list");
                });
            this.closedelete();
        },
        closedelete() {
            this.DeleteRowdata = false;
        },
        closeShow() {
            this.showRowData = false;
        },
        TypeChange(data) {
            this.sourceRules = [];
            this.channelRules = [];
            if (data === 'all') {
                if( this.type_data.channel.length===0){
                    this.type_data.channel = []
                }
                if(   this.type_data.source.length===0){
                    this.type_data.source = []
                }
                console.log(this.sourceRules,"kkkkkkkkkkkkkkk")
                this.sourceRules = [
                    (v) => !!v.length || "Please select at least one Lead Source"
                ];
                this.channelRules = [
                    (v) => !!v.length || "Please select at least one Channel"
                ];
            } else if (data === 'source') {
                if(   this.type_data.source.length===0){
                    this.type_data.source = []
                }
                this.type_data.channel = []
                console.log(this.sourceRules,"kkkkkkkkkkkkkkk")
                this.sourceRules = [
                    (v) => !!v.length || "Lead Source is required"
                ];
            } else if (data === 'channel') {
                if( this.type_data.channel.length===0){
                    this.type_data.channel = []
                }
                this.type_data.source = []
                this.channelRules = [
                    (v) => !!v.length || "Channel is required"
                ];
            }
        },
        liveagent(response, user) {
            let scope = this
            let startup_payload = {
                number: "",
                Queue: "",
                agent: "",
                team_user: JSON.parse(localStorage.getItem("admin_emails")),
                Campaign: "",
                Type: "",
                Status: "",
                Extension: "",
                team_name: ""
            }

            scope.$store
                .dispatch("liveagents", startup_payload)
                .then(function (result) {
                    var result_data = result.data.data;
                    scope.liveagents_users = result_data.map(elm => elm.user)

                    let admin_emails = JSON.parse(localStorage.getItem("admin_emails"));
                    let agent_emails = JSON.parse(localStorage.getItem("agent_emails"));

                    if (response.status == 200) {
                        let membersinteam = response.data.data;
                        agent_emails = agent_emails.filter((email) => !membersinteam.includes(email));
                        scope.allmembers = [...admin_emails, ...agent_emails];
                    } else if (response.status == 204) {
                        scope.allmembers = [...admin_emails, ...agent_emails];
                    }

                    if (user !== undefined) {
                        scope.allmembers = [...scope.allmembers, ...user];
                    }
                    scope.allmembers = scope.allmembers.map((email) => {

                        return {
                            displayname: scope.liveagents_users.includes(email) ? email + "- Live Agent" : email,
                            name: email,
                            active: scope.liveagents_users.includes(email)
                        };
                    });



                })
                .catch(function (error) {
                    scope.showSnackBar("error" + error);
                });

        },
        toggleUser(user, type) {
            if (type == 'create') {
                const index = this.addTeam.payload.user.indexOf(user);
                if (index > -1) {
                    // If user is already selected, remove from array
                    this.addTeam.payload.user.splice(index, 1);
                } else {
                    // If user is not selected, add to array
                    this.addTeam.payload.user.push(user);
                }
            } else if (type == 'update') {
                const index = this.editTeam.user.indexOf(user);
                if (index > -1) {
                    // If user is already selected, remove from array
                    this.editTeam.user.splice(index, 1);
                } else {
                    // If user is not selected, add to array
                    this.editTeam.user.push(user);

                }
            }

        },
        selectAll() {

            if (this.selectall === false || this.selectall === undefined) {
                this.selectall = false
                this.value = [];
            } else {
                this.value = this.allmembers.filter(member => member.active === false).map(member => member.name);
                if (this.allSelected) {
                    this.selectall = true
                } else {
                    setTimeout(() => {
                        this.selectall = false
                    }, 1000);

                }
            }

        },
    },
    computed: {

        allSelected() {
            // Checks if all items in 'itemsValue' are selected
            return this.value.length === this.allmembers.length;
        },

        CreateSelectAll() {
            return this.addTeam.payload.user.length === this.team_user.length
        },
        Createlike() {
            return this.addTeam.payload.user.length > 0 && !this.CreateSelectAll
        },
        icon() {
            if (this.CreateSelectAll) return 'mdi-close-box'
            if (this.Createlike) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        UpdateSelectAll() {
            return this.editTeam.user.length === this.team_user.length
        },
        Updatelike() {
            return this.editTeam.user.length > 0 && !this.UpdateSelectAll
        },
        Updateicon() {
            if (this.UpdateSelectAll) return 'mdi-close-box'
            if (this.Updatelike) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        }
    },
    mounted() {
        this.TypeChange("all")
        let scope = this;
        this.page.loading = false;
        this.team_user = JSON.parse(localStorage.getItem("group_users"));
        setTimeout(
            function () {
                if (
                    scope.$store.getters.UserPermissions.indexOf(
                        "management:team:create"
                    ) !== -1
                ) {
                    scope.page.addnew = [{ label: "Add Team" }];
                }
                if (
                    scope.$store.getters.UserPermissions.indexOf(
                        "management:team:edit"
                    ) !== -1
                ) {
                    scope.page.canedit = true;
                }
                if (
                    scope.$store.getters.UserPermissions.indexOf(
                        "management:team:delete"
                    ) !== -1
                ) {
                    scope.page.candelete = true;
                }
            }.bind(scope),
            1
        );
        this.userdata("")
        this.getDataFromApi();
        this.getdata()


    },
    watch: {
        pagination: {
            handler() {
                this.getDataFromApi()
            },
            deep: true,
        },
    },
    destroyed() {
        clearInterval(this.liveAgentTime)
        this.userdata("")
    }
};
</script>
<style scoped>

@media (max-width: 1480px){
    .teamhight{
        height: 545px !important;
      overflow: auto !important;
    }  
}
@media (max-width: 1184px){
    .teamhight{
        height: 550px !important;
      overflow: auto !important;
    }  
}
@media (max-width: 987px){
    .teamhight{
        height: 450px !important;
      overflow: auto !important;
    }  
}
@media (max-width: 846px){
    .teamhight{
        height: 380px !important;
      overflow: auto !important;
    }  
}
</style>